import React from 'react';
import { Button, Tooltip } from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { useReport } from '../ReportContext';
import { useItemNavigation } from '../hooks/useItemNavigation';

// Export a simple function for direct access to view data handling
// Note: This function is kept for backward compatibility but should use Filter Framework
export function openViewDataURL(viewDataUrl) {
  if (!viewDataUrl) return;
  window.open(viewDataUrl, '_blank');
}

export const ViewDataButton = ({ config }) => {
  // Get drilldown state from ReportContext
  const drilldownState = useReport();
  // Use our new navigation hook
  const { handleViewDataClick } = useItemNavigation(config, drilldownState);

  // Only render if viewData is configured
  if (!config.viewData) {
    return null;
  }

  return (
    <Tooltip title="View Data">
      <Button
        variant="contained"
        size="small"
        onClick={handleViewDataClick}
        startIcon={<VisibilityIcon fontSize="small" />}
        sx={{
          height: '32px',
          backgroundColor: 'rgb(48,122,215)',
          color: '#ffffff',
          '&:hover': {
            backgroundColor: 'rgb(38,97,171)',
          }
        }}
      >
        View Data
      </Button>
    </Tooltip>
  );
}; 
